import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'LinkifyPipe',
  pure: true,
})
export class LinkifyPipe implements PipeTransform {
  #sanitizer = inject(DomSanitizer);

  transform(value: string): SafeHtml {
    if (!value) return value;
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const linked = value.replace(
      urlRegex,
      '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>'
    );
    return this.#sanitizer.bypassSecurityTrustHtml(linked);
  }
}
